'use client';

import { usePathname } from 'next/navigation';

// Keep the public gateway return outside providers that contact protected APIs.
export default function PaymentReturnBoundary({ children, portal }: {
  children: React.ReactNode;
  portal: React.ReactNode;
}) {
  const pathname = usePathname();
  return <>{pathname.replace(/\/$/, '') === '/payment-complete' ? children : portal}</>;
}
